import { action, ActionType } from "typesafe-actions";
import { UserData } from "../../../pages/login/types/user-data.interface";
import { AuthToken } from "../../user/types/auth-token.interface";

export enum AuthActions {
  Authenticate = "Auth/Authenticate",
  AuthenticateSuccess = "Auth/AuthenticateSuccess",
  AuthenticateFailure = "Auth/AuthenticateFailure",
  FetchAccessToken = "Auth/FetchAccessToken",
  FetchAccessTokenSuccess = "Auth/FetchAccessTokenSuccess",
  DestroySession = "Auth/DestroySession",
}

export const authenticate = () => action(AuthActions.Authenticate);
export const authenticateSuccess = (userId: number) =>
  action(AuthActions.AuthenticateSuccess, userId);
export const authenticateFailure = (error: any) => action(AuthActions.AuthenticateFailure, error);

export const fetchAccessToken = (userData: UserData) =>
  action(AuthActions.FetchAccessToken, userData);

export const fetchAccessTokenSuccess = (token: AuthToken) =>
  action(AuthActions.FetchAccessTokenSuccess, token);

export const destroySession = () => action(AuthActions.DestroySession);

const actionCreators = {
  authenticate,
  authenticateSuccess,
  authenticateFailure,
  fetchAccessToken,
  fetchAccessTokenSuccess,
  destroySession,
};

export type AuthActionType = ActionType<typeof actionCreators>;
